import { IonIcon } from '@ionic/react';
import styled, { css } from 'styled-components';
import { informationCircleOutline } from 'ionicons/icons';
import { useEffect, useRef, useState } from 'react';

interface ToolTipProps {
    message: string
}

const ToolTipContainer = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: baseline;
    cursor: pointer;
`;

const ToolTipText = styled.div<any>`
    width: max-content;
    height: max-content;
    background-color: #737373;
    color: ${({ theme }) => theme.colors.main.color};
    text-align: left;
    border-radius: 6px;
    padding: 10px;
    font-size: 11px;
    line-height:14px;
    font-weight: 400;
    /* Position the tooltip */
    position: absolute;
    bottom: 25px;
    left: 5px;
    z-index: 200;
    transition: 300ms ease-in-out all;
    overflow: hidden;
    max-width:152px;
    ${props => props.visible ? css`
        opacity:1;
        pointer-events:all; 
        box-shadow: rgba(0, 0, 0, 0.4) 0px 30px 90px;
    ` : `
        opacity:0;
        pointer-events:none;
    `}
`;

var messageVisibilityTimeout:any = null;
const maxMessageVisibleTime = 5 * 1000;

const ToolTip = (props: ToolTipProps) => {

    const { message } = props;
    const ToolTipRef = useRef<any>(null);
    const [messageVisible, toggleMessageVisible] = useState<boolean>(false);

    function handleChangeRequest() {
        toggleMessageVisible(prev => !prev);
    }

    //Close tool tip on click ouside of the element
    function closeToolTipListener () {
        document.addEventListener('click',(event:any) => {
            if(ToolTipRef.current && !ToolTipRef.current.contains(event.target)) {
                toggleMessageVisible(false);
            }
        })
    }

    useEffect(() => {
        closeToolTipListener();
    }, [])

    //Handle timeout of closing the message
    useEffect(() => {
        if(messageVisible) {
            clearTimeout(messageVisibilityTimeout);
            messageVisibilityTimeout = setTimeout(() => {
                toggleMessageVisible(false);
                messageVisibilityTimeout = null;
            }, maxMessageVisibleTime);
        } else if(messageVisibilityTimeout) {
            clearTimeout(messageVisibilityTimeout);
        }
    }, [messageVisible])

    return (
        <ToolTipContainer onClick={handleChangeRequest} ref={ToolTipRef} >
            <IonIcon style={{'color': '#FFCC00'}} src={informationCircleOutline} />
            <ToolTipText visible={messageVisible} >{message}</ToolTipText>
        </ToolTipContainer>
    )
}

export default ToolTip